import type { AreaComponent, PlacementPosition, Surface } from '@repo/api-contracts';
import { clampCylinderPlacementPosition, clampPlacementPosition } from '@/entities/edit-area';

/**
 * 옮긴 위치를 표면 규칙 안으로 자른다(끌어 옮기기·화살표 키가 함께 쓴다). 원통은 계약 원통 배치 규칙(ADR-0007 D9)이라
 * 음수 x 와 프레임보다 넓은 Component(둘레 2W 까지)를 받고, 그 밖의 표면은 실측 사각형 안으로 자른다. 어디에도 둘 수 없으면 null.
 */
export const clampToSurface = (
  component: AreaComponent,
  surface: Surface,
  position: PlacementPosition,
): PlacementPosition | null =>
  surface.type === 'cylinder'
    ? clampCylinderPlacementPosition(component, surface.realSize, position)
    : clampPlacementPosition(component, surface.realSize, position);
